<template>
  <span class="previewImage" :class="{ hover, hide }" @click="handleClick">
    <img :src="getAssetsUrl(src)" alt="" @error="handleError" />
  </span>
</template>
<script setup lang="ts">
import { getAssetsUrl } from '@/utils/index'
import { ref } from 'vue'

const props = withDefaults(
  defineProps<{
    src: string
    /** 鼠标悬停效果 */
    hover?: boolean
    /** 图片加载失败时隐藏图片 */
    errorHide?: boolean
  }>(),
  {
    hover: true,
  }
)

const emit = defineEmits(['click', 'error'])
function handleClick() {
  emit('click')
}

const hide = ref(false)
function handleError() {
  if (props.errorHide) {
    hide.value = true
  }
  emit('error')
}
</script>
<style lang="less" scoped>
.previewImage {
  width: 100%;
  height: 100%;
  display: inline-block;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    transition: all 0.2s;
    object-fit: cover;
  }
  &.hide {
    display: none;
  }
  &.hover:hover {
    img {
      transform: scale(1.2);
    }
  }
}
</style>
